<template>
    <div>
        <div v-if="loading" class="pa-loading"><img src="/public/img/loading-bar.gif" /></div>

        <div v-else class="u-mt-20" style="padding: 20px 12px;">
            <h4>Minhas matrículas na rede</h4>
            <p class="pa-sub">Histórico de matrículas, com situação e características.</p>

            <el-alert v-if="erro" type="warning" :closable="false" show-icon :title="erro" />

            <div v-else-if="matriculas.length === 0" class="pa-vazio">
                Nenhuma matrícula encontrada.
            </div>

            <el-table v-else :data="matriculas" stripe size="mini" style="width:100%">
                <el-table-column label="Ano" width="80">
                    <template slot-scope="s">{{ s.row.periodo_letivo || '—' }}</template>
                </el-table-column>
                <el-table-column label="Escola" min-width="160">
                    <template slot-scope="s">{{ s.row.escola || '—' }}</template>
                </el-table-column>
                <el-table-column label="Curso / Turma" min-width="150">
                    <template slot-scope="s">
                        <strong>{{ s.row.curso || '—' }}</strong>
                        <div class="pa-menor">{{ s.row.turma || '' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Turno" width="100" class-name="hidden-mobile">
                    <template slot-scope="s">{{ s.row.turno || '—' }}</template>
                </el-table-column>
                <el-table-column label="Situação" width="130">
                    <template slot-scope="s">
                        <!-- O backend já devolve o texto: o portal não traduz código numérico. -->
                        <el-tag size="mini" :type="corSituacao(s.row.situacao_matricula)">
                            {{ s.row.situacao_matricula || '—' }}
                        </el-tag>
                        <div v-if="s.row.situacao_academica" class="pa-menor">{{ s.row.situacao_academica }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
/**
 * BLOCO N — item 17. Consome `api/portal/minhas-matriculas`. O aluno vem do token: não há
 * `aluno_id` no payload, e o backend nunca aceitaria um.
 */
export default {
    name: 'PortalMatriculas',

    data: () => ({ loading: true, erro: null, matriculas: [] }),

    mounted () { this.carregar() },

    methods: {
        carregar () {
            this.loading = true
            this.erro = null

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/minhas-matriculas`,
                             {}, this.$store.getters.getHeaderAuth).then(r => {

                this.loading = false
                const d = r.data || {}
                if (d.erro) { this.erro = d.erro; return }

                this.matriculas = d.matriculas || []

            }).catch(() => {
                this.loading = false
                this.erro = 'Não foi possível carregar suas matrículas.'
            })
        },

        corSituacao (texto) {
            if (!texto) return 'info'
            const t = String(texto).toLowerCase()
            if (t.indexOf('ativa') === 0) return 'success'
            if (t.indexOf('conclu') === 0) return 'primary'
            if (t.indexOf('cancel') === 0 || t.indexOf('evad') === 0) return 'danger'
            return 'info'
        }
    }
}
</script>

<style scoped>
.pa-loading { min-height: 350px; display: flex; justify-content: center; align-items: center; }
.pa-sub { color: #909399; }
.pa-menor { color: #909399; font-size: 12px; }
.pa-vazio { padding: 26px 12px; text-align: center; color: #909399; background: #fafafa; border-radius: 4px; }
@media (max-width: 640px) { .hidden-mobile { display: none !important; } }
</style>
